const FormError = ({ content, visible }) => {
  if (!visible) return <></>;
  return <div className="form-user-error-tip">{content}</div>;
};

export default FormError;
